import { HttpErrorResponse } from '@angular/common/http';

export interface IUiError {
  url: string;
  code: string;
  params?: { [appParam: string]: string };
  message?: string;
  status?: number;
}

export const UiError = (error: unknown): IUiError => {
  const e: IUiError = {
    url: '',
    code: 'Unknown',
    message: error as string,
    status: 0,
  };
  if (error instanceof HttpErrorResponse) {
    e.url = error.url || '';
    e.message = error.message || '';
    e.status = error.status || 0;
    if (error.error) {
      e.params = error.error.appParams;
      e.message = error.error.errorMessages?.join('. ');
      e.code = error.error.appCode || error.error.errorCode || 'Unknown';
    }
  }
  return e;
};
